exports.components = {
  "component---src-pages-404-tsx": () => import("./../../../src/pages/404.tsx" /* webpackChunkName: "component---src-pages-404-tsx" */),
  "component---src-templates-legacy-page-tsx": () => import("./../../../src/templates/legacy_page.tsx" /* webpackChunkName: "component---src-templates-legacy-page-tsx" */)
}

